/* Prime 151 - Notify Me flow state. One shared modal per page, opened by any
   [data-p151-notify] trigger (collection card span or PDP button).

   SUBMIT MODEL - read snippets/p151-notify-global.liquid before changing.
   Native form submit only. AJAX is impossible here: Shopify's invisible hCaptcha only
   attaches its token on the browser's native submit path (fetch gets 400 "Missing CAPTCHA\n   token"), and the hidden-iframe workaround dies on the storefront's
   frame-ancestors 'none' CSP. So: submit natively, Shopify redirects back to this same
   page with form.posted_successfully?, and we restore the modal on the confirmation pane
   using the pending handle stashed in localStorage just before submit.

   ALT EMAIL (owner decision 0716): a signed-in Vault Keeper may send the signal to a
   different address. That tags THAT email as its own contact - it does NOT touch their
   account email. Shopify keys customers by email, so a different address is a different
   contact by definition, not a duplicate. We never rewrite an account email from here:
   that's their login credential, and the storefront customer form can't do it anyway.
   We just say plainly where the signal is going.

   State: customer waitlist-<handle> tag when logged in, localStorage for guests. */
(function () {
  function all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var ov, paneForm, paneDone, form, input, sendBtn, errEl, acctEl, hintEl, altEl, clearBtn, tagsEl, noteEl;
  var current = { handle: '', title: '', url: '' };
  var PENDING = 'p151wl:pending';

  function key(h) { return 'p151wl:' + h; }

  function onList(h) {
    if (!h) return false;
    if ((window.p151Waitlist || '').indexOf('waitlist-' + h + ',') > -1) return true;
    try { return localStorage.getItem(key(h)) === '1'; } catch (e) { return false; }
  }

  function remember(h) { try { localStorage.setItem(key(h), '1'); } catch (e) {} }

  function markSet(el) {
    el.setAttribute('data-p151-state', 'set');
    el.classList.add('p151-signal-set');
    el.textContent = 'Signal Set';
  }

  function markAll(h) {
    all('[data-p151-notify]').forEach(function (el) {
      if (el.getAttribute('data-handle') === h) markSet(el);
    });
  }

  function paint() {
    all('[data-p151-notify]').forEach(function (el) {
      if (el.getAttribute('data-p151-state') === 'set') return;
      if (onList(el.getAttribute('data-handle'))) markSet(el);
    });
  }

  function show() { ov.hidden = false; document.body.style.overflow = 'hidden'; }
  function hide() { ov.hidden = true; document.body.style.overflow = ''; }

  function setTitle(t) {
    all('[data-p151-title]').forEach(function (el) { el.textContent = t; });
  }

  function syncClear() {
    if (clearBtn) clearBtn.hidden = !input.value;
  }

  // Signed in + typed a different address: say where the signal is going and that their
  // account email is untouched. Only fires once what they've typed is a valid address,
  // so it doesn't nag mid-keystroke.
  function syncAlt() {
    if (!altEl) return;
    var acct = window.p151Email;
    var val = (input.value || '').trim();
    var differs = !!acct && !!val && val.toLowerCase() !== acct.toLowerCase() && input.checkValidity();
    if (differs) {
      altEl.textContent = "We'll send this signal to " + val + ". Your account email stays " + acct + ".";
      altEl.hidden = false;
      if (hintEl) hintEl.hidden = true;
    } else {
      altEl.hidden = true;
      if (hintEl) hintEl.hidden = !acct;
    }
  }

  function openFor(el) {
    current.handle = el.getAttribute('data-handle') || '';
    current.title = el.getAttribute('data-title') || '';
    current.url = el.getAttribute('data-url') || '';
    setTitle(current.title);
    if (tagsEl) tagsEl.value = 'waitlist, waitlist-' + current.handle;
    if (noteEl) noteEl.value = 'Back-in-stock waitlist: ' + current.title;
    paneForm.hidden = false;
    paneDone.hidden = true;
    errEl.hidden = true;

    // Prefill the signed-in Vault Keeper's account email. Stays fully editable, and the
    // inline X wipes it in one tap so they can type another.
    if (window.p151Email) {
      input.value = window.p151Email;
      if (hintEl) hintEl.hidden = false;
    } else {
      input.value = '';
      if (hintEl) hintEl.hidden = true;
    }
    if (altEl) altEl.hidden = true;
    syncClear();

    show();
    try { input.focus(); } catch (e) {}
  }

  function onSubmit() {
    try {
      localStorage.setItem(PENDING, JSON.stringify({ h: current.handle, t: current.title }));
    } catch (e) {}
    sendBtn.disabled = true;
    sendBtn.textContent = 'Sending...';
  }

  // After the reload: server says posted_successfully, and we stashed a pending handle.
  // Both must be true - otherwise an unrelated customer form on the page (e.g. the footer
  // newsletter) would pop this modal open.
  function restoreAfterPost() {
    if (!window.p151Posted) return false;
    var raw = null;
    try { raw = localStorage.getItem(PENDING); } catch (e) {}
    if (!raw) return false;
    try { localStorage.removeItem(PENDING); } catch (e) {}
    var p;
    try { p = JSON.parse(raw); } catch (e) { return false; }
    if (!p || !p.h) return false;
    remember(p.h);
    markAll(p.h);
    setTitle(p.t || '');
    paneForm.hidden = true;
    paneDone.hidden = false;
    if (acctEl && !window.p151LoggedIn) acctEl.hidden = false;
    show();
    return true;
  }

  function init() {
    ov = document.getElementById('p151nm-ov');
    if (!ov) return;
    paneForm = ov.querySelector('[data-pane="form"]');
    paneDone = ov.querySelector('[data-pane="done"]');
    form = ov.querySelector('.p151nm__form');
    input = ov.querySelector('.p151nm__in');
    sendBtn = ov.querySelector('.p151nm__send');
    errEl = ov.querySelector('.p151nm__err');
    acctEl = ov.querySelector('.p151nm__acct');
    hintEl = ov.querySelector('.p151nm__hint');
    altEl = ov.querySelector('.p151nm__alt');
    clearBtn = ov.querySelector('.p151nm__clear');
    tagsEl = ov.querySelector('[data-p151-tags]');
    noteEl = ov.querySelector('[data-p151-note]');

    form.addEventListener('submit', onSubmit);
    input.addEventListener('input', function () { syncClear(); syncAlt(); });
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        syncClear();
        syncAlt();
        try { input.focus(); } catch (e) {}
      });
    }
    ov.querySelector('.p151nm__x').addEventListener('click', hide);
    ov.querySelector('.p151nm__done').addEventListener('click', hide);
    ov.addEventListener('click', function (e) { if (e.target === ov) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) hide(); });

    // Capture phase so the collection card's wrapping <a> never navigates.
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('[data-p151-notify]') : null;
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      if (el.getAttribute('data-p151-state') === 'set') {
        var u = el.getAttribute('data-url');
        if (u) window.location.href = u;
        return;
      }
      openFor(el);
    }, true);

    paint();
    restoreAfterPost();

    // PDP: hide the native sold-out submit + qty picker where the notify button lives.
    all('notify-me-modal').forEach(function (n) {
      var sec = n.closest('.shopify-section') || document;
      var sb = sec.querySelector('.product-form__submit');
      if (sb) sb.style.display = 'none';
      var qty = sec.querySelector('.product-form__quantity');
      if (qty) qty.style.display = 'none';
    });

    var note = document.querySelector('.p151-preorder-note');
    if (note) {
      var ps = note.closest('.shopify-section') || document;
      var sp = ps.querySelector('.product-form__submit span');
      if (sp) sp.textContent = 'Pre-Order Now';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();